<template>
    <div class="header-breadcrumb">
        <el-breadcrumb>
            <el-breadcrumb-item v-for="(item,index) in list" :key="index">
               {{item.meta.title}}
            </el-breadcrumb-item>
            <template v-if="show">
                <el-link :underline="false" @click="onGoBackHandle" type="primary">
                    返回
                </el-link>
            </template>
        </el-breadcrumb>
    </div>
</template>
<script>
export default{
    name:"headerBreadcrumb",
    props:{
        list:{
            type:Array,
            default:()=>{
                return []
            }
       }
    },
     data(){
        return {
            show:false
        }
    },
    watch:{
        list:{
            handler(item){
                item.forEach(row=>{
                    if(!row.meta.show){
                        this.show = true
                    }else{
                        this.show = false
                    }
                })
            },
            deep:true
        }
    },
    methods:{
        onGoBackHandle(){
            this.$router.back()
        }
    }
}
</script>
<style scoped>
.header-breadcrumb{
    padding: 16px 10px;
    background-color: #ffffff;
    border-left:1px solid #ebebeb;
}
</style>



// WEBPACK FOOTER //
// src/components/header-breadcrumb/index.vue